import { apiRequest } from '@/utils/api-request';

interface GetPresignedUrlParams {
  orgId: string;
  collectionId: string;
  filename: string;
  expiresIn?: number;
  download?: boolean;
}

interface PresignedUrlResponse {
  presigned_url: string;
  expires_in: number;
  download: boolean;
  detail?: string;
}

export const getPresignedDownloadUrl = async ({
  orgId,
  collectionId,
  filename,
  expiresIn = 3600,
  download = true,
}: GetPresignedUrlParams) => {
  const response = await apiRequest<PresignedUrlResponse>({
    url: `/uploads/${orgId}/${collectionId}/${encodeURIComponent(
      filename,
    )}/presigned-url?expires_in=${expiresIn}&download=${download}`,
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    return {
      detail:
        response.detail || 'Failed to generate download link for the file',
    };
  }

  return response?.data;
};
